import React from "react";
import DatePicker, {registerLocale} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {useDispatch, useSelector} from "react-redux";
import {date_field_change} from "../../redux/actions";
import el from "date-fns/locale/ru";

registerLocale("el", el);


export const DepartureDate = () => {
    const dispatch = useDispatch()
    const value = useSelector(state => state.app.fields.departureDate.value)
    const error = useSelector(state => state.app.fields.departureDate.error)
    const minDate = useSelector(state => state.app.fields.departureDate.minDate)
    return (
        <React.Fragment>
            <label htmlFor="date">Дата отправки</label>
            <div className="datepicker">
                <DatePicker id="departure_date"
                            className={'date-input' + (error ? ' error' : '')}
                            name="departure_date"
                            placeholder="Выбрать"
                            dateFormat="dd/MM/yyyy"
                            minDate={minDate}
                            locale={el}
                            selected={value}
                            onChange={(date) => dispatch(date_field_change('departure_date', date))}
                />
            </div>
        </React.Fragment>
    )
}